export default __webpack_public_path__ + "static/media/wood_dig_store.5de09cad.png";